import { render, staticRenderFns } from "./timeInUiChartByTensionBeats.vue?vue&type=template&id=08ffe55a"
import script from "./timeInUiChartByTensionBeats.vue?vue&type=script&lang=js"
export * from "./timeInUiChartByTensionBeats.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports